import React from 'react';

import { MDText } from 'i18n-react';

import { Button, ChevronRightIcon, ShieldIcon } from '@motorway/mw-highway-code';
import { Hyperlink } from '@motorway/mw-highway-code/alpha';
import { SIZE } from '@motorway/mw-highway-code/enums';

import { VERIFICATION_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsDocumentVerification';

import { Modal } from 'Storybook/components/local/Modal/Modal';

import LocalTexts from './OurTrustedProviderModal.texts.json';

import styles from './OurTrustedProviderModal.scss';

const LocalT = new MDText(LocalTexts);

export const OurTrustedProviderModal: React.FC = () => {
  const [isOpenModal, setIsOpenModal] = React.useState(false);

  const onModalOpen = () => {
    setIsOpenModal(true);
    VERIFICATION_ANALYTICS_EVENTS.TRUSTED_PARTNER_MODAL_OPEN();
  };

  const onModalClose = () => {
    setIsOpenModal(false);
    VERIFICATION_ANALYTICS_EVENTS.TRUSTED_PARTNER_MODAL_CLICK();
  };

  const LINK_TO_PRIVACY_POLICY = '/privacy-policy';

  const privacyPolicy = <Hyperlink href={LINK_TO_PRIVACY_POLICY} label={LocalT.translate('privacyPolicy')} onClick={() => VERIFICATION_ANALYTICS_EVENTS.PRIVACY_POLICY_OPEN()} target="_blank" />;

  const modalProps = { className: styles.container, contentClass: styles.modalContent, dialogClass: styles.modal, dismissModal: onModalClose, size: 'small' };

  return <>
    <a className={styles.privacyInfoBox}
      href="#"
      onClick={onModalOpen}>
      <ShieldIcon size={SIZE.LARGE} />
      <div className={styles.content}>
        <h5 className={styles.title}>{LocalT.translate('documentsSecure.title')}</h5>
        <p data-thc-style-override>{LocalT.translate('documentsSecure.link')}</p>
      </div>
      <span className={styles.arrowIcon}><ChevronRightIcon /></span>
    </a>

    {isOpenModal && <Modal {...modalProps}>
      <h3 className={styles.heading}>{LocalT.translate('trustedProviderModalTitle')}</h3>
      <div className={styles.content}>
        <p>{LocalT.translate('trustedProviderModalContent1')}</p>
        <p>{LocalT.translate('trustedProviderModalContent2')}</p>
        <p>{LocalT.translate('trustedProviderModalContent3')}</p>
        <p data-thc-style-override>{LocalT.translate('trustedProviderModalContent4', { privacyPolicy })}</p>
      </div>
      <div className={styles.buttonContainer}>
        <Button fullWidth label={LocalT.translate('trustedProviderModalConfirm')} onClick={onModalClose}/>
      </div>
    </Modal>}

  </>;
};
